const tabsRow = {
  state: {
    allTabs: [],
    activeTab: null
  },
  mutations: {
    UPDATE_ACTIVE_TAB: (state, activeTab) => {
      state.activeTab = activeTab
    },
    ADD_TAB: (state, payload) => {
      if (state.allTabs.some(t => t.tab_id === payload.tab_id)) { return }
      state.allTabs.push({
        ...payload
      })
    },
    DELETE_TAB: (state, tabObj) => {
      for (const [i, t] of state.allTabs.entries()) {
        if (t.tab_id === tabObj.tab_id) {
          state.allTabs.splice(i, 1)
          break
        }
      }
    },
    DELETE_TAB_OTHERS: (state, rightClickedTab) => {
      for (const [i, t] of state.allTabs.entries()) {
        if (t.tab_id === rightClickedTab.tab_id) {
          state.allTabs = state.allTabs.slice(i, i + 1)
          break
        }
      }
    },
    DELETE_TAB_ALL: state => {
      state.allTabs = []
    }
  },
  actions: {
    activeTab({ commit, state }, activeTab) {
      commit('UPDATE_ACTIVE_TAB', activeTab)
    },
    addTab({ commit }, route) {
      // generate tab_title
      //
      let theTitle = ''
      if (route.query.topParentName) {
        // taskmanager
        theTitle = route.query.topParentName.trim()
      } else if (route.params.viewName) {
        // views with names, views using wrapper
        theTitle = route.params.viewName
      } else if (route.name) {
        theTitle = route.name
      } else {
        theTitle = '-'
      }

      // topParentID and viewName CAN NEVER BOTH BE DEFINED
      //
      let topParentID = ''
      if (route.query.topParentID) {
        topParentID = route.query.topParentID
      }
      let viewName = ''
      if (route.params.viewName) {
        viewName = route.params.viewName
      }
      const theMatch = route.name + '-' + topParentID + viewName

      // s
      //
      let tN = route.name
      if (
        route.name === 'Reports'
        || route.name === 'Contact'
        || route.name === 'Property'
      ) {
        tN = 'Wrapper'
      }

      // commit new view
      //
      commit('ADD_TAB', {
        tab_title: theTitle,
        tab_type: tN,
        tab_fullPath: route.fullPath,
        tab_id: theMatch
      })
    },
    deleteTab({ commit, state }, tabObj) {
      return new Promise(resolve => {
        commit('DELETE_TAB', tabObj)
        resolve([...state.allTabs])
      })
    },
    delOthersViews({ commit, state }, rightClickedTab) {
      return new Promise(resolve => {
        commit('DELETE_TAB_OTHERS', rightClickedTab)
        resolve([...state.allTabs])
      })
    },
    delAllViews({ commit, state }) {
      return new Promise(resolve => {
        commit('DELETE_TAB_ALL')
        resolve([...state.allTabs])
      })
    }
  },
  getters: {
    activeTab: state => state.activeTab,
    allTabs: state => state.allTabs
  }
}

export default tabsRow
